import { Language } from '@prisma/client';
import {
  CONTENTFUL_ENGLISH_KEY,
  CONTENTFUL_SWISS_GERMAN_KEY,
  RaffleItemResDto,
  RaffleTime,
  RaffleStatus,
} from '@web/common';
import { DateTime } from 'luxon';

function hasPointsSpent(
  data: RaffleItemResDto,
): data is Extract<
  RaffleItemResDto,
  { status: Exclude<RaffleStatus, RaffleStatus.NotParticipating> }
> {
  return data.status !== RaffleStatus.NotParticipating;
}

export function getRaffleTime(startDate: DateTime, endDate: DateTime) {
  if (startDate > DateTime.now()) {
    return RaffleTime.Future;
  }
  if (startDate < DateTime.now() && endDate > DateTime.now()) {
    return RaffleTime.Active;
  }
  return RaffleTime.Past;
}

export function getRaffleData(data: RaffleItemResDto, language: string) {
  const translationKey =
    language === Language.de
      ? CONTENTFUL_SWISS_GERMAN_KEY
      : CONTENTFUL_ENGLISH_KEY;

  const startDate = data.fields.startDate[CONTENTFUL_ENGLISH_KEY];
  const endDate = data.fields.endDate[CONTENTFUL_ENGLISH_KEY];

  const title = data.fields?.title[translationKey];
  const imageUrl =
    data.fields?.prizeImage[CONTENTFUL_ENGLISH_KEY].fields.file[
      CONTENTFUL_ENGLISH_KEY
    ].url; // img only has en
  const betPoints = hasPointsSpent(data) ? data.pointsSpent : undefined;

  return {
    startDate,
    endDate,
    title,
    imageUrl,
    betPoints,
    getRaffleTime,
    status: data.status,
    raffleId: data.sys.id,
  };
}
